import React from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Download as DownloadIcon, FileArchive, CheckCircle } from 'lucide-react';

const Download = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/villa-thailand-landingpage.zip';
    link.download = 'villa-thailand-landingpage.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white flex items-center justify-center px-4 py-16">
      <Card className="max-w-2xl w-full p-8 md:p-12 shadow-2xl">
        <div className="text-center space-y-6">
          <div className="flex justify-center">
            <FileArchive className="w-20 h-20 text-amber-600" />
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900">
            Villa Thailand Landingpage
          </h1>
          
          <p className="text-lg text-gray-600">
            Deine fertige Landingpage als ZIP-Datei zum Download
          </p>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 text-left">
            <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-amber-600" />
              Was ist enthalten?
            </h3>
            <ul className="space-y-2 text-gray-700">
              <li>📦 <strong>build/</strong> - Fertige Website (zum Upload auf deinen Webserver)</li>
              <li>📝 <strong>src/</strong> - Quellcode (für Anpassungen)</li>
              <li>📖 <strong>README.md</strong> - Dokumentation</li>
              <li>🚀 <strong>INSTALLATION.md</strong> - Upload-Anleitung</li>
            </ul>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-left text-sm">
            <p className="text-gray-700">
              <strong>Größe:</strong> 560 KB<br/>
              <strong>Format:</strong> ZIP-Archiv<br/>
              <strong>Bereit für:</strong> Apache/Nginx Webserver
            </p>
          </div>

          <Button
            onClick={handleDownload}
            size="lg"
            className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white px-8 py-6 text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 w-full md:w-auto"
          >
            <DownloadIcon className="w-6 h-6 mr-2" />
            ZIP-Datei herunterladen
          </Button>

          <div className="pt-6 border-t border-gray-200">
            <h4 className="font-semibold text-gray-900 mb-2">Nach dem Download:</h4>
            <ol className="text-left text-gray-700 space-y-2 list-decimal list-inside">
              <li>ZIP-Datei entpacken</li>
              <li>In den <code className="bg-gray-100 px-2 py-1 rounded">build/</code> Ordner gehen</li>
              <li>Alle Dateien auf deinen Webserver hochladen</li>
              <li>Fertig! 🎉</li>
            </ol>
          </div>

          <div className="pt-4">
            <a 
              href="/" 
              className="text-amber-600 hover:text-amber-700 font-medium transition-colors"
            >
              ← Zurück zur Landingpage
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Download;
